import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { pluck } from "@app/services/api.service"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "@app/common-imports"
import { DatePickerComponent } from "@app/utils/date-picker/date-picker.component"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-change-limit-date",
	imports: [
		COMMON_IMPORTS,
		DatePickerComponent,
		CancelBtnComponent,
		BtnExtComponent,
		LangValPipe,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="row">
			<div class="col-8">
				<app-date-picker
					[actualObj]="this"
					[errors]="errors"
					fieldName="series_limit_date"
					title_ph_lang="forever"
					tabindex="-1"
					(changeEvent)="validateEntireForm()"
					[addonObject]="{ after: { text: ('ends_at' | langVal) } }"
				>
				</app-date-picker>
			</div>
		</div>

		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<app-btn-ext
				text="change_limit_date"
				[disabled]="!isFormSubmittable"
				(clickEv)="submit()"
				[isSpin]="isSaving"
			/>
		</div>
	`,
})
export class ChangeLimitDateComponent extends Modalable {
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	isSaving: boolean = false //while waiting for the api to return from saving (controls save btn disabled and outputs a "waiting" gif)
	errors: any = {} //will hold errors for the fields in the form
	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		series_limit_date: { today_and_later: null },
	}

	@Input() fus_id: number = 0
	@Input() series_limit_date: string = ""

	validateEntireForm() {
		this.isFormSubmittable = this.validator.validateEntireForm(
			this,
			this.errors,
			this.validationFields
		)
	}

	async submit() {
		if (!this.isFormSubmittable) {
			return
		} //has errors - exit
		if (this.isSaving) {
			return
		} //is curently waiting for api to finish saving - exit
		this.isSaving = true //flag "waiting for the api to finish saving" as true
		const res: any = await this.apiService.post(
			"change_series_limit_date",
			this,
			"series_limit_date,fus_id"
		)
		const message = res.success ? "updated_successfully" : "save_failed"
		if (res.success) {
			this.store.updateFus(this.fus_id, pluck(this, "series_limit_date"))
			this.onClose.emit(true)
		}
		this.modalService.openToast(message)
		//......
		// this.isSaving = false;	//flag "waiting for the api to finish saving" as false
		// this.onClose.emit(true);
	}
}
